/*! DO NOT EDIT: This file is auto-generated and will be overwritten. [build-fingerprint:assets:source={/app/_js/standalone/collection-boost-sd-custom/index.js}] */
"use strict";
(() => {
  // _js/standalone/collection-boost-sd-custom/index.js
  window.dataLayer = window.dataLayer || [];
  var METRIC_SIZES = {
    "9x12'": "274x366cm",
    "8x10'": "244x305cm",
    "6x9'": "183x274cm",
    "5x7'": "152x213cm",
    "Runner (2.5x10')": "Runner (91x152cm)",
    "Runner (2.5x7')": "Runner (76x305cm)",
    "3x5'": "36x213cm"
  }, convertToMetricSize = (size) => METRIC_SIZES[size] ?? size, usesMetricSize = () => window.Shopify?.
  currency?.active === "GBP";
  window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
    (componentRegistry) => {
      componentRegistry.useModulePlugin("FilterAPI", {
        name: "FilterAPI plugin",
        apply(builder) {
          builder.on("methodFulfilled", "get", (payload) => {
            let PREFIX_MAP = {
              tag: "pf_t_",
              option: "pf_opt_",
              variant: "pf_v_",
              collection: "pf_ct_",
              vendor: "pf_v_vendor",
              price: "pf_p_"
            }, toSlug = (str) => str.toLowerCase().replace(/&/g, "").replace(/\s+/g, "-").replace(/-+/g,
            "-").replace(/^-|-$/g, ""), toTitle = (str) => str.replace(/^(collection|tag|option|variant)_/i,
            "").replace(/\b\w/g, (c) => c.toUpperCase()), formatLabel = (str) => {
              let m = /pfs:label-(.*)/i.exec(str);
              return m ? m[1].replace(/-/g, " ").trim() : toTitle(str);
            }, getSwatchUrl = (key) => (window.__tvgSwatchOverrides || {})[key] || (window.__tvgSwatchBaseUrl ||
            "") + "icon-filter-" + toSlug(key) + ".png", getFilterPrefix = (filter) => {
              if (filter.filterOptionId)
                return filter.filterOptionId;
              if (filter.prefix && filter.prefix.startsWith("pf_"))
                return filter.prefix;
              let slug = (filter.label || "").toLowerCase().replace(/\s+/g, "_");
              return (PREFIX_MAP[filter.filterType] || "pf_opt_") + slug;
            };
            try {
              let data = payload.result || payload, filters = data.filter || data.filters || [];
              Array.isArray(filters) || (filters = filters.options || filters.filterOptionItems || []),
              Array.isArray(filters) || (filters = []);
              let shouldUseMetric = usesMetricSize(), cache = {};
              for (let filter of filters) {
                let name = filter.label || filter.title || "";
                if (!name)
                  continue;
                let isColor = name.toLowerCase() === "color", isSize = name.toLowerCase() === "size",
                options = (filter.values || filter.filterOptionItems || []).map((v) => {
                  let rawLabel = v.label || v.title || v.key || "", key = v.key || v.handle || rawLabel,
                  count = v.doc_count ?? v.count ?? 1;
                  if (!key || count <= 0)
                    return null;
                  let displayLabel = shouldUseMetric && isSize ? convertToMetricSize(rawLabel) : formatLabel(
                  rawLabel) || key;
                  shouldUseMetric && isSize && (v.label = displayLabel, v.title && (v.title = displayLabel));
                  let item = {
                    label: displayLabel,
                    key,
                    selected: !!v.selected
                  };
                  return isColor && (item.image = getSwatchUrl(key)), item;
                }).filter(Boolean);
                options.length > 0 && (cache[name] = { prefix: getFilterPrefix(filter), options });
              }
              Object.keys(cache).length > 0 && (window.__tvgFilterCache = cache, window.dispatchEvent(
              new CustomEvent("tvg:filters-ready")));
            } catch (e) {
              console.warn("[TVG] methodFulfilled error:", e);
            }
            return payload;
          }), builder.on("beforeMethodCall", "get", (payload) => {
            let collectionHandle = window.location.pathname.split("/").pop(), sizeSelected = payload.
            args[0].pf_opt_size;
            sizeSelected ? sessionStorage.setItem("selectedOption", sizeSelected[0]) : collectionHandle.
            includes("3x5") ? sessionStorage.setItem("selectedOption", "3x5'") : collectionHandle.includes(
            "5x7") ? sessionStorage.setItem("selectedOption", "5x7'") : collectionHandle.includes("6\
x9") ? sessionStorage.setItem("selectedOption", "6x9'") : collectionHandle.includes("8x10") ? sessionStorage.
            setItem("selectedOption", "8x10'") : collectionHandle.includes("9x12") ? sessionStorage.
            setItem("selectedOption", "9x12'") : sessionStorage.setItem("selectedOption", "");
          });
        }
      }), componentRegistry.useComponentPlugin("ProductList", {
        name: "Add Click Listener",
        enabled: !0,
        apply: () => ({
          afterRender() {
            document.querySelectorAll(
              ".boost-sd__product-link"
            ).forEach((link) => {
              link.addEventListener("click", () => {
                let clickUrl = link.getAttribute("href"), productTitle = link.closest(".boost-sd__pr\
oduct-item").querySelector(".boost-sd__product-title").innerText || "";
                window.dataLayer.push({
                  event: "plp_clickthrough",
                  page_path: window.location.pathname,
                  click_URL: clickUrl,
                  product_name: productTitle
                });
              });
            });
          }
        })
      });
      let hardcodedBadgeColors = {
        frida: { bg: "#3e4b0d", color: "#faf5ea" }
      }, badgeDataCache = /* @__PURE__ */ new Map(), newBadgePosition = document.body.getAttribute("\
data-new-badge-position") === "true", fetchMeta = (handle) => {
        if (badgeDataCache.has(handle))
          return badgeDataCache.get(handle);
        let promise = fetch(
          `${window.Shopify.routes.root}products/${handle}?view=meta-json`
        ).then((res) => res.json()).catch(() => ({}));
        return badgeDataCache.set(handle, promise), promise;
      }, fetchProductBadges = (handle) => fetchMeta(handle).then((res) => res && res.badges || []), fetchBadgePalette = (handle) => fetchMeta(
      handle).then((res) => {
        let productBadges = res && res.badges || [], palette = res && res.badgePalette || [], merged = [
        ...productBadges, ...palette], seen = /* @__PURE__ */ new Set();
        return merged.filter((badge) => {
          let text = badge?.text || badge?.title || badge?.name || badge?.label || "", key = String(
          text).trim().toLowerCase();
          return !key || seen.has(key) ? !1 : (seen.add(key), !0);
        });
      }), FRIDA_SVG = `<svg viewbox="0 0 582.3 111.5" width="74" height="14">
        <path fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" stroke-lin\
ejoin="round" d="M58.2,11.7c.9,10.9,5.9,75.2-11.2,90.7"></path>
        <path fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" stroke-lin\
ejoin="round" d="M127.1,23.6C62.1,21.8,6.6,35.4,6.6,35.4"></path>
        <path fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" stroke-lin\
ejoin="round" d="M35.1,63.3s1.9,3,60.9.9"></path>
        <path fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" stroke-lin\
ejoin="round" d="M99.1,107.3s23.1-6.3,23.1-63.7c1.1-.2,4.3,10.6,25.5,15.8-9.1,34.7,25.4,48.8,31.8,9.\
4-3,36.4,31.9,24.4,38.9,4"></path>
        <path fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" stroke-lin\
ejoin="round" d="M182.6,49.8c-1.2,0-1.2,1.8,0,1.8,1.2,0,1.2-1.8,0-1.8Z"></path>
        <path fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" stroke-lin\
ejoin="round" d="M252.1,71.2c-5.4-17.8-44.3,18.4-21.3,22.2,12.8-3.1,21.5-17.6,21.5-17.6"></path>
        <path fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" stroke-lin\
ejoin="round" d="M255.8,27.5c-5.5,54.3-2.7,79.6-2.7,79.6"></path>
        <path fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" stroke-lin\
ejoin="round" d="M285.2,70.6c-32.1-3.4-27.7,55.7,6.1,8.3-2.7,23.5,23.8,16.7,30,5.8"></path>
        <path fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" stroke-lin\
ejoin="round" d="M370.5,5.7s-10,45.8-11.5,92.9"></path>
        <path fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" stroke-lin\
ejoin="round" d="M410.9,4.2c0,18.1-89.6,88.5-101.4,34.3,25.9.7,90.5,58.5,92.9,56.7"></path>
        <path fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" stroke-lin\
ejoin="round" d="M435.6,67.7c-31.2-4.5-25.8,52.8,6.1,8.3-2.6,23.5,23.7,16.7,30,5.8,0,0,7.9-11.4,16.3\
-42.9s3.3-13.7,3.7-17.3c-21.9-28.2-20.1,69-14.1,70.7,1.5,2.7,8-25,16.6-25s3.9,25.9,12.2,26.2c10.2,10\
.3,48.1-68.6,22.6-60.6-5.1,7.1-14,43.4-1.2,55.9,9.9,9.7,24.7,3.6,29.1.9,34.3,19,15.9-42.7-11.6-10.7"\
></path>
      </svg>`, applyFridaSvg = (span) => {
        span.parentElement.setAttribute("data-badge-type", "frida"), span.parentElement.style.backgroundColor =
        hardcodedBadgeColors.frida.bg, span.parentElement.style.color = hardcodedBadgeColors.frida.color,
        span.innerHTML = FRIDA_SVG;
      }, isSaleText = (text = "") => {
        let lower = text.toLowerCase();
        return lower.includes("%") || lower.includes(" off") || lower.includes("sale") || lower.includes(
        "discount");
      }, applyHardcodedColor = (span) => {
        let lowerText = span.innerText.toLowerCase();
        for (let [key, colors] of Object.entries(hardcodedBadgeColors))
          if (lowerText.includes(key))
            return span.parentElement.style.backgroundColor = colors.bg, span.parentElement.style.color =
            colors.color, !0;
        return !1;
      }, createPillBadge = (text, bgColor, textColor) => {
        let isMobile = window.matchMedia("(max-width: 767px)").matches, pill = document.createElement(
        "span");
        return pill.className = "boost-sd__badge-pill", pill.innerText = text, pill.style.cssText = `\

        display: inline-flex;
        justify-content: center;
        align-items: center;
        padding: 0.125rem 0.625rem;
        border-radius: 12px;
        background-color: ${bgColor};
        color: ${textColor};
        font-family: 'ABC Marfa', sans-serif;
        font-size: 0.775rem;
        font-weight: 500;
        line-height: 1.5;
        letter-spacing: -0.01em;
        text-transform: uppercase;
        white-space: nowrap;
      `, pill;
      }, createFridaPill = () => {
        let pill = createPillBadge(
          "",
          hardcodedBadgeColors.frida.bg,
          hardcodedBadgeColors.frida.color
        );
        return pill.setAttribute("data-badge-type", "frida"), pill.innerHTML = FRIDA_SVG, pill;
      }, normalizeBadgeMatch = (text = "") => text.toLowerCase().trim().replace(/-/g, " ").replace(/pct/g,
      "%").replace(/[^a-z0-9%]+/g, " ").trim(), getBadgeColors = (badge) => ({
        background: badge?.backgroundColor || badge?.background_color || badge?.background_color?.value ||
        badge?.backgroundColor?.value || "#eeeeee",
        text: badge?.textColor || badge?.text_color || badge?.text_color?.value || badge?.textColor?.
        value || "#444444"
      }), getBadgeText = (badge) => badge?.text || badge?.title || badge?.name || badge?.label || "",
      findMatchingBadge = (badges, text) => {
        let normalizedText = normalizeBadgeMatch(text), exactMatch = badges.find(
          (badge) => normalizeBadgeMatch(getBadgeText(badge)) === normalizedText
        );
        if (exactMatch)
          return exactMatch;
        let discountValue = normalizedText.match(/(\d+)\s*%/)?.[1];
        return discountValue && badges.find((badge) => normalizeBadgeMatch(getBadgeText(badge)).includes(
        `${discountValue}%`)) || null;
      };
      componentRegistry.useComponentPlugin("ProductList", {
        name: "Add Tag Color Change",
        enabled: !0,
        apply: () => ({
          afterRender() {
            document.querySelectorAll(
              ".boost-sd__product-item"
            ).forEach((card) => {
              let labelSpans = card.querySelectorAll(
                ".boost-sd__product-label-text"
              ), link = card.querySelector(".boost-sd__product-link"), href = link ? link.getAttribute(
              "href") : null, handle = href ? href.split("/products/").pop()?.split("?")[0] : null;
              if (newBadgePosition) {
                let productInfo = card.querySelector(".boost-sd__product-info"), currentGen = (Number(
                card.getAttribute("data-badge-gen")) || 0) + 1;
                card.setAttribute("data-badge-gen", String(currentGen));
                let pillContainer = card.querySelector(
                  ".boost-sd__badge-pills-container"
                );
                pillContainer && (pillContainer.innerHTML = "");
                let getOrCreatePillContainer = () => pillContainer || (productInfo ? (pillContainer =
                document.createElement("div"), pillContainer.className = "boost-sd__badge-pills-cont\
ainer", pillContainer.style.cssText = `
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  flex-wrap: wrap;
                  gap: 6px;
                  width: 100%;
                `, productInfo.insertBefore(pillContainer, productInfo.firstChild), pillContainer) :
                null), saleSpans = [];
                if (labelSpans.forEach((span) => {
                  let label = span.parentElement, spanText = span.innerText;
                  if (spanText.toLowerCase().includes("frida") || label.getAttribute("data-badge-typ\
e") === "frida") {
                    label.style.display = "none";
                    return;
                  }
                  isSaleText(spanText) ? saleSpans.push(span) : label.style.display = "none";
                }), !handle)
                  return;
                Promise.all([
                  fetchProductBadges(handle),
                  fetchBadgePalette(handle)
                ]).then(([badges, palette]) => {
                  if (Number(card.getAttribute("data-badge-gen")) !== currentGen)
                    return;
                  let container = getOrCreatePillContainer();
                  if (!container)
                    return;
                  let pillCount = 0;
                  saleSpans.forEach((span) => {
                    if (pillCount >= 2)
                      return;
                    let match = findMatchingBadge(palette, span.innerText), colors = getBadgeColors(
                    match), displayText = span.innerText.replace(/-/g, " ").replace(/pct/gi, "%");
                    container.appendChild(
                      createPillBadge(displayText, colors.background, colors.text)
                    ), span.parentElement.style.display = "none", pillCount++;
                  }), badges.forEach((badge) => {
                    if (pillCount >= 2)
                      return;
                    let text = getBadgeText(badge);
                    if (!(!text || saleSpans.length > 0 && saleSpans.some((span) => {
                      let saleNorm = normalizeBadgeMatch(span.innerText), badgeNorm = normalizeBadgeMatch(
                      text);
                      if (saleNorm === badgeNorm)
                        return !0;
                      let discountValue = saleNorm.match(/(\d+)\s*%/)?.[1];
                      return !!(discountValue && badgeNorm.includes(`${discountValue}%`) && isSaleText(
                      text));
                    }))) {
                      if (badge.frida || text.toLowerCase().includes("frida"))
                        container.appendChild(createFridaPill());
                      else {
                        let colors = getBadgeColors(badge);
                        container.appendChild(
                          createPillBadge(text, colors.background, colors.text)
                        );
                      }
                      pillCount++;
                    }
                  });
                });
              } else
                labelSpans.forEach((span) => {
                  let spanText = span.innerText;
                  if (spanText.toLowerCase().includes("frida") || span.parentElement.getAttribute("d\
ata-badge-type") === "frida") {
                    applyFridaSvg(span);
                    return;
                  }
                  if (spanText.toLowerCase().includes("%")) {
                    span.parentElement.style.marginRight = "auto";
                    return;
                  }
                  handle ? fetchBadgePalette(handle).then((badges) => {
                    let match = findMatchingBadge(badges, spanText);
                    if (match) {
                      let colors = getBadgeColors(match);
                      span.parentElement.style.backgroundColor = colors.background, span.innerText =
                      span.innerText.replace(/-/g, " ").replace(/pct/gi, "%"), span.parentElement.style.
                      color = colors.text;
                    } else
                      applyHardcodedColor(span);
                  }) : applyHardcodedColor(span);
                });
            });
          }
        })
      }), componentRegistry.useComponentPlugin("ProductPrice", {
        name: "Return current variant price",
        enabled: !0,
        apply: () => ({
          beforeRender(element) {
            let selectedOption = sessionStorage.getItem("selectedOption"), formatMoney = window.Shopify.
            formatMoney, moneyFormat = "${{amount_no_decimals}}";
            window?.Shopify?.currency?.active === "GBP" && (moneyFormat = "\xA3{{amount_no_decimals}}");
            let rootElement = element.getRootElm(), product = componentRegistry.getParentElmByPath(
              element,
              "ProductItem.ProductLink"
            ).getParams().props.product, variants = product.variants, discountTag = product.tags.find(
            (tag) => tag.includes("discount:")) || "discount:0", discount = Number(discountTag.split(
            ":")[1]), currentVariant = variants.find(
              (variant) => selectedOption && variant.title.indexOf(selectedOption) !== -1
            );
            if (currentVariant) {
              let basePrice = window.igData?.price?.getPriceByVariantId(currentVariant.id) || currentVariant.
              price;
              if (discount) {
                let originalPrice = basePrice, salePrice = originalPrice * (1 - discount / 100), span = document.
                createElement("span");
                span.classList.add("boost-sd__product-price-original"), span.innerText = `${formatMoney(
                originalPrice * 100, moneyFormat)}`, rootElement.innerText = `${formatMoney(salePrice *
                100, moneyFormat)}`, rootElement.insertAdjacentHTML("afterbegin", span.outerHTML);
              } else
                rootElement.innerText = `${formatMoney(basePrice * 100, moneyFormat)}`;
            } else if (product.price_min < product.price_max) {
              let productId = product.id, minPrice = window.igData?.price?.getMinPriceByProductId(productId) ||
              product.price_min, maxPrice = window.igData?.price?.getMaxPriceByProductId(productId) ||
              product.price_max;
              if (discount) {
                let salePriceMin = minPrice * (1 - discount / 100), salePriceMax = maxPrice * (1 - discount /
                100);
                rootElement.innerText = `${formatMoney(salePriceMin * 100, moneyFormat)} - ${formatMoney(
                salePriceMax * 100, moneyFormat)}`;
              } else
                rootElement.innerText = `${formatMoney(minPrice * 100, moneyFormat)} - ${formatMoney(
                maxPrice * 100, moneyFormat)}`;
            } else {
              let basePrice = window.igData?.price?.getPriceByVariantId(
                product.variants[0].id
              ) || product.variants[0].price;
              if (discount) {
                let originalPrice = basePrice, salePrice = originalPrice * (1 - discount / 100), span = document.
                createElement("span");
                span.classList.add("boost-sd__product-price-original"), span.innerText = `${formatMoney(
                originalPrice * 100, moneyFormat)}`, rootElement.innerText = `${formatMoney(salePrice *
                100, moneyFormat)}`, rootElement.insertAdjacentHTML("afterbegin", span.outerHTML);
              } else
                rootElement.innerText = `${formatMoney(basePrice * 100, moneyFormat)}`;
            }
          }
        })
      }), componentRegistry.useComponentPlugin("ProductPrice", {
        name: "Add product label",
        enabled: !0,
        apply: () => ({
          beforeRender(element) {
            let rootElement = element.getRootElm(), handle = componentRegistry.getParentElmByPath(
              element,
              "ProductItem.ProductLink"
            ).getParams().props.product.handle;
            fetch(
              `${window.Shopify.routes.root}products/${handle}?view=meta-json`
            ).then((res) => res.json()).then((res) => {
              let productLabelData = res.label, previousSibling = rootElement.previousElementSibling;
              if (productLabelData) {
                if (previousSibling?.classList.contains(
                  "boost-sd__product-custom-label"
                ))
                  return;
                let div = document.createElement("div");
                div.classList.add("boost-sd__product-custom-label"), div.innerText = productLabelData.
                text, div.style.color = productLabelData.color, div.style.fontStyle = productLabelData.
                style, rootElement.insertAdjacentHTML("beforebegin", div.outerHTML);
              }
            });
          }
        })
      }), componentRegistry.useComponentPlugin("ProductImage", {
        name: "Return current variant image",
        enabled: !0,
        apply: () => ({
          beforeRender(element) {
            let selectedOption = sessionStorage.getItem("selectedOption"), currentMainImage = element.
            getRootElm().querySelector(
              ".boost-sd__product-image-img--main"
            );
            if (!currentMainImage)
              return;
            let currentMainImageSrc = currentMainImage.src, currentVariant = componentRegistry.getParentElmByPath(
              element,
              "ProductItem.ProductLink"
            ).getParams().props.product.variants.find(
              (variant) => selectedOption && variant.title.indexOf(selectedOption) !== -1
            );
            currentVariant && (currentMainImage.src = currentVariant.image, currentMainImage.srcset =
            currentMainImage.srcset.replaceAll(
              currentMainImageSrc,
              currentVariant.image
            ));
          }
        })
      }), componentRegistry.useComponentPlugin("ProductTitle", {
        name: "Add Rug Cover Label",
        enabled: !0,
        apply: () => ({
          beforeRender(element) {
            let rootElement = element.getRootElm(), nextSibling = rootElement.nextElementSibling, rugCoverLabelMetafield = componentRegistry.
            getParentElmByPath(
              element,
              "ProductItem.ProductLink"
            ).getParams().props.product.metafields.find(
              (metafield) => metafield.namespace === "product_card" && metafield.key === "rug_cover_\
label"
            );
            if (rugCoverLabelMetafield && !nextSibling.classList.contains("boost-sd__product-rug-lab\
el")) {
              let rugCoverLabel = rugCoverLabelMetafield.value, div = document.createElement("div");
              div.classList.add("boost-sd__product-rug-label"), div.innerText = rugCoverLabel, rootElement.
              insertAdjacentHTML("afterend", div.outerHTML);
            }
          }
        })
      }), componentRegistry.useComponentPlugin("ProductItem", {
        name: "Remove duplicate labels (Boost issue)",
        enabled: !0,
        apply: () => ({
          beforeRender(element) {
            let labels = element.getRootElm().querySelectorAll(".boost-sd__product-label"), seenLabels = /* @__PURE__ */ new Set();
            labels.forEach((label) => {
              let labelText = label.innerText.toLowerCase().replace(/-/g, " ").replace(/pct/g, "%");
              seenLabels.has(labelText) ? label.remove() : seenLabels.add(labelText);
            });
          }
        })
      }), componentRegistry.useComponentPlugin("PaginationNumber", {
        name: "Add pagination number accessibility",
        enabled: !0,
        apply: () => ({
          afterRender(element) {
            let rootElement = element.getRootElm();
            if (!rootElement)
              return;
            let pageNumber = rootElement.textContent.trim(), isActive = rootElement.classList.contains(
              "boost-sd__pagination-number--active"
            );
            rootElement.classList.contains(
              "boost-sd__pagination-number--disabled"
            ) && pageNumber === "..." ? (rootElement.setAttribute("aria-hidden", "true"), rootElement.
            setAttribute("tabindex", "-1")) : (rootElement.setAttribute("aria-label", `Go to page ${pageNumber}`),
            isActive && (rootElement.setAttribute("aria-current", "page"), rootElement.setAttribute(
              "aria-label",
              `Page ${pageNumber}, current page`
            )));
          }
        })
      }), componentRegistry.useComponentPlugin("PaginationButton", {
        name: "Add pagination button accessibility",
        enabled: !0,
        apply: () => ({
          afterRender(element) {
            let rootElement = element.getRootElm();
            if (!rootElement)
              return;
            let isPrev = rootElement.classList.contains(
              "boost-sd__pagination-button--prev"
            ), isNext = rootElement.classList.contains(
              "boost-sd__pagination-button--next"
            );
            isPrev && rootElement.setAttribute("aria-label", "Go to previous page"), isNext && rootElement.
            setAttribute("aria-label", "Go to next page");
          }
        })
      });
    }
  ]);
})();
